// Helper functions
import { 
  collection, 
  addDoc, 
  getDocs, 
  doc, 
  updateDoc, 
  query, 
  orderBy, 
  serverTimestamp,
  deleteDoc
} from 'firebase/firestore';
import { db } from '../config/firebase';

export const saveOrder = async (order) => {
  try {
    console.log('Attempting to save order:', order);
    
    if (!db) {
      throw new Error('Firestore database instance is not initialized');
    }

    const orderToSave = {
      ...order,
      createdAt: serverTimestamp(),
      status: order.status || 'pending'
    };
    
    console.log('Prepared order for saving:', orderToSave);
    
    const ordersCollection = collection(db, 'orders');
    console.log('Got orders collection reference');
    
    const docRef = await addDoc(ordersCollection, orderToSave);
    console.log('Order saved successfully with ID:', docRef.id);
    
    return { ...orderToSave, id: docRef.id };
  } catch (error) {
    console.error('Detailed error saving order:', {
      message: error.message,
      code: error.code,
      stack: error.stack
    });
    throw error;
  }
};

export const getAllOrders = async () => {
  try {
    const ordersQuery = query(
      collection(db, 'orders'),
      orderBy('createdAt', 'desc')
    );
    
    const querySnapshot = await getDocs(ordersQuery);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate().toISOString() || new Date().toISOString()
    }));
  } catch (error) {
    console.error('Error getting orders:', error);
    throw error;
  }
};

export const updateOrderStatus = async (orderId, status) => {
  try {
    const orderRef = doc(db, 'orders', orderId);
    await updateDoc(orderRef, { 
      status,
      updatedAt: serverTimestamp()
    });
    return true;
  } catch (error) {
    console.error('Error updating order status:', error);
    throw error;
  }
};

export const deleteOrder = async (orderId) => {
  try {
    const orderRef = doc(db, 'orders', orderId);
    await deleteDoc(orderRef);
    return true;
  } catch (error) {
    console.error('Error deleting order:', error);
    throw error;
  }
};
